import React, {useEffect, useState} from "react";
import { Link } from 'react-router-dom';
import './styles.scss';

const ButtonLink = (props) => {
    const renderIcon = () => {
        if (!props.icon) return null;
        
        // Check if icon is already a JSX element (React element)
        if (React.isValidElement(props.icon)) {
            return props.icon;
        }
        
        // If it's a component reference, render it
        const IconComponent = props.icon;
        return <IconComponent />;
    };

    return (
        <Link className={`button-link ${props.version ? props.version : ''} ${props.size ? props.size : ''} ${props.className ? props.className : ''}`} to={props.to}>
            {props.label} {renderIcon()}
        </Link>
    );
};

export default ButtonLink;
